import { media, styled } from '@styles';
import { css } from 'styled-components';

export const Modal = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  display: flex;
  max-width: 1120px;
  ${media.largeScreen`
    max-width: 930px;
  `}
  ${media.mediumScreen`
    width: 100%;
    max-width: initial;
  `}
  ${media.smallScreen`
    display: block;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  ${media.xSmallScreen`
    flex-direction: column;
  `}
`;

export const Header = styled.div`
  width: 100%;
`;

export const Content = styled.div`
  width: 100%;
  padding: 80px;
  & > p {
    text-align: center;
    position: relative;
    font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
    font-size: ${({ theme: { typography } }) => typography.baseFontSize};
    margin: ${({ theme: { spacing } }) =>
      `${spacing.spacer} auto ${spacing.spacer} auto`};
    width: 80%;
    &:before {
      content: '';
      display: block;
      width: 110%;
      height: 1px;
      left: -14px;
      top: -35px;
      position: absolute;
      background-color: #b9c5cb;
      opacity: 0.5;
      ${media.mediumScreen`
        top: -18px;
      `}
      ${media.smallScreen`
        top: 0;
      `}
    }
    ${media.mediumScreen`
      font-size: 14px;
    `}
  }
  ${media.largeScreen`
    padding: 82px 67px 84px;
  `}
  ${media.mediumScreen`
    width: 100%;
    padding: 70px;
    max-width: 330px;
  `}
  ${media.smallScreen`
    padding: 36px 20px 50px;
    max-width: initial;
  `}
`;

export const Left = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme: { colors } }) => colors.light};
  ${media.mediumScreen`
    width: 100%;
    position: relative;
  `}
  ${media.smallScreen`
    padding-top: 37px;
  `}
  ${media.xSmallScreen` {
    height: 35vh;
    padding-bottom: 18px;
    flex-shrink: 0;
  `}
`;

export const Right = styled.div<{ fullWidth: boolean }>`
  width: ${(props) => (props.fullWidth ? '100%' : '50%')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${media.mediumScreen`
    width: 100%;
  `}
`;

export const Image = styled.img<{ fullWidth: boolean }>`
  ${({ theme, fullWidth }) => css`
    width: auto;
    height: 72px;
    margin-bottom: 0;
    ${fullWidth &&
    css`
      margin-top: calc(${theme.spacing.spacer} * 4);
    `}
    ${media.largeScreen`
      height: 62px;
    `}
    ${media.smallScreen`
      height: 46px;
    `}
  `}
`;

export const Title = styled.h4`
  font-family: ${({ theme: { typography } }) => typography.thinFontFamily};
  font-family: ${({ theme: { typography } }) => typography.h5FontSize};
  margin-top: 38px;
  margin-bottom: ${({ theme: { spacing } }) => `calc(${spacing.spacer} * 2.5)`};
  text-align: center;
  line-height: 120%;
  width: 100%;
  ${media.largeScreen`
    margin-top: 36px;
  `}
  ${media.mediumScreen`
    margin-top: 30px;
    margin-bottom: 50px;
    width: 50%;
  `}
  ${media.smallScreen`
    width: 100%;
    margin-top: 27px;
    margin-bottom: 32px;
    line-height: 100%;
  `}
`;

export const Text = styled.p`
  text-align: center;
  font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
  font-size: ${({ theme: { typography } }) => typography.smallFontSize};
  margin-bottom: ${({ theme: { spacing } }) => `calc(${spacing.spacer} * 4)`};
  width: 75%;
  opacity: 0.8;
  ${media.mediumScreen`
    margin-bottom: ${({ theme: { spacing } }) => spacing.spacer};
    width: 50%;
  `}
  ${media.smallScreen`
    margin-top: 0;
    margin-bottom: ${({ theme: { spacing } }) => spacing.spacer};
    width: 100%;
  `}
  ${media.xSmallScreen` {
    margin-bottom: ${({ theme: { spacing } }) =>
      `calc(${spacing.spacer} * 0.7)`};
    line-height: 120%;
  `}
`;

export const ContentWishlist = styled.div`
  display: flex;
  justify-content: center;
`;

export const ProductImage = styled.img`
  width: 60%;
  mix-blend-mode: darken;
  ${media.xSmallScreen`
    height: 100%;
    width: auto;
  `}
`;

export const ProductTitle = styled.p`
  width: 60%;
  position: relative;
  font-size: ${({ theme: { typography } }) => typography.h4FontSize};
  ${media.largeScreen`
    width: 75%;
  `}
  ${media.mediumScreen`
    position: absolute;
    bottom: 60px;
  `}
  ${media.smallScreen`
    width: 85%;
    bottom: 30px;
  `}
`;

export const ProductCategory = styled.p`
  width: 60%;
  position: relative;
  text-transform: capitalize;
  font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
  font-family: ${({ theme: { typography } }) => typography.smallFontSize};
  color: ${({ theme: { colors } }) => colors.graySemi};
  margin-bottom: 8px;
  margin-top: 8px;
  ${media.largeScreen`
    width: 75%;
  `}
  ${media.mediumScreen`
    position: absolute;
    bottom: 90px;
  `}
  ${media.smallScreen`
    width: 85%;
    line-height: 160%;
    margin-bottom: 0;
    bottom: 60px;
  `}
`;

export const ShareIconsWrapper = styled.div`
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  width: 80%;
  ${media.smallScreen`
    button {
      svg {
        height: 33px;
        width: 33px;
      }
    }

    button:not(:last-child) {
      height: 40px;
      width: 40px;
      margin-right: 8px;
    }
  `}
`;

export const SaveButton = styled.div`
  ${media.mediumScreen`
    margin-top: ${({ theme: { spacing } }) => spacing.spacer};
  `}
`;

export const SaveSelectLoader = styled.div<{ loading: boolean }>`
  position: absolute;
  left: 50%;
  height: 100%;
  transform: translate(-50%, 10%);
  opacity: ${({ loading }) => (loading ? 1 : 0)};
  span {
    background-color: ${({ theme: { colors } }) => colors.red};
    width: 12px;
    height: 12px;
    ${media.smallScreen`
      width: 10px;
      height: 10px;
    `}
  }
`;

export const SaveSelectIcon = styled.div`
  width: 68px;
  height: 100%;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-child {
    background: #f5f1f2;
  }
  ${media.largeScreen`
    width: 60px;
  `}
  ${media.smallScreen`
    width: 50px;
  `}

  img {
    width: 20px;
    height: auto;
    ${media.smallScreen`
      width: 14px;
    `}
    &.arrow {
      width: 10px;
      height: 9px;
      opacity: 0.5;
      transition: opacity 0.25s ease;
    }
  }
`;

export const SaveSelectText = styled.div`
  padding-left: 23px;
  flex-grow: 1;
  display: flex;
  align-items: center;
  text-align: left;
  ${media.largeScreen`
    padding-left: 19px;
  `}
`;

export const SaveSelect = styled.div`
  .save-select__btn {
    position: relative;
    padding: 0;
    height: 68px;
    width: 100%;
    font-family: ${({ theme: { typography } }) => typography.baseFontFamily};
    font-size: ${({ theme: { typography } }) => typography.baseFontSize};
    line-height: 20px;
    letter-spacing: initial;
    text-transform: initial;
    color: ${({ theme: { colors } }) => colors.baseFont};
    margin-top: 10px;
    background-color: #ffffff;
    border: 1px solid #f0f1f2;
    border-radius: 6px;
    transition: box-shadow 0.25s ease;
    cursor: pointer;
    &--loading {
      ${SaveSelectText} {
        opacity: 0;
      }
    }
    ${media.largeScreen`
      height: 60px;
      line-height: 16px;
    `}
    ${media.mediumScreen`
    `}
    ${media.smallScreen`
      height: 50px;
      line-height: 14px;
    `}

    & > span {
      display: flex;
      justify-content: space-between;
      height: 100%;
    }

    &:hover {
      border-radius: 6px;
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.07);
      overflow: hidden;
      transition: box-shadow 0.25s ease;

      ${SaveSelectIcon} {
        .arrow {
          opacity: 1;
          transition: opacity 0.25s ease;
        }
      }
    }
  }
`;
